module.exports = __webpack_public_path__ + "static/media/Xc47-logo.7a40a17d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Xc47/Xc47-logo.svg
// module id = 666
// module chunks = 0